exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* @import url(\"/assets/style/style.css\"); */\n/* @import url(\"/assets/font-awesome/css/font-awesome.min.css\"); */\n\n.footer {\n    position: bottom;\n    bottom: 0;\n    width: 100%;\n    /* Set the fixed height of the footer here */\n    height: 80px;\n    line-height: 60px;\n    /* Vertically center the text there */\n    background-color: #262F36;\n    padding-left: 1em;\n    padding-right: 1em;\n    /* background-color: red; */\n}\n\n.footer-img {\n    height: 80px;\n}\n\n.footer-text {\n    width: 100%;\n    background-color: #262F36;\n    padding-left: 1em;\n    padding-bottom: 1em;\n    /* background-color: red; */\n    color: white;\n    font-weight: bold;\n}\n.footer-slide {\n    /* height: 80px; */\n    /* max-height: 80px; */\n    width: 100%;\n    background-color: #262F36;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/footer-bar/footer-bar.component.css
// module id = 405
// module chunks = 0